import React from 'react';

// Official Facebook logo: blue circle with a white "f". Crisp at any size.
export function FacebookIcon({ className = '', size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="12" fill="#1877F2" />
      <path
        fill="#FFFFFF"
        d="M15.36 12.94l.53-3.43h-3.29V7.28c0-.94.46-1.85 1.94-1.85h1.5V2.51S14.6 2.28 13.29 2.28c-2.74 0-4.53 1.66-4.53 4.66v2.57H5.74v3.43h3.02v8.29h3.71v-8.29h2.89z"
      />
    </svg>
  );
}
